import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    show_price_container: {
        display: 'flex',
        gap: '10px',
    },
    number: {
        fontFamily: 'Alkatra, cursive',
        fontSize: '18px',
        "& > span:last-child":{
            fontSize: '18px',
        }
    },
    positive: {
        color: `${theme.palette.success.light}c9`
    },
    negative: {
        color: theme.palette.error.light
    },
    title: {
        fontSize: '12px',
        color: theme.palette.grey["600"],
        fontWeight: 800
    },
}));

export {useStyles}